import React from 'react';

import BundleHeaderPageSegment from '../components/BundleHeaderPageSegment';
import BundlePricingPageSegment from '../components/BundlePricingPageSegment';
import PageRoot from '../components/PageRoot';

const propTypes = {};

function Bundle() {
  return (
    <PageRoot>
      <BundleHeaderPageSegment />
      <BundlePricingPageSegment />
    </PageRoot>
  );
}

Bundle.propTypes = propTypes;

export default Bundle;
